const OIDC_AUTOLOGIN_BLOCK_KEY = 'rugira_oidc_autologin_block';
const OIDC_AUTOLOGIN_BLOCK_TTL_MS = 30000;
const OIDC_LOGIN_ATTEMPT_KEY = 'rugira_oidc_login_attempt';
const OIDC_LOGIN_ATTEMPT_TTL_MS = 2 * 60 * 1000;

const readRawBlock = (): { until: number; reason: string | null } | null => {
  try {
    const raw = sessionStorage.getItem(OIDC_AUTOLOGIN_BLOCK_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as { until?: unknown; reason?: unknown };
    const until = typeof parsed?.until === 'number' ? parsed.until : NaN;
    if (!Number.isFinite(until)) {
      sessionStorage.removeItem(OIDC_AUTOLOGIN_BLOCK_KEY);
      return null;
    }
    return {
      until,
      reason: typeof parsed?.reason === 'string' && parsed.reason.trim() ? parsed.reason : null,
    };
  } catch {
    return null;
  }
};

export const setOidcAutoLoginBlock = (reason?: string): void => {
  try {
    const payload = {
      until: Date.now() + OIDC_AUTOLOGIN_BLOCK_TTL_MS,
      reason: reason?.trim() || null,
    };
    sessionStorage.setItem(OIDC_AUTOLOGIN_BLOCK_KEY, JSON.stringify(payload));
  } catch {
    /* ignore */
  }
};

export const clearOidcAutoLoginBlock = (): void => {
  try {
    sessionStorage.removeItem(OIDC_AUTOLOGIN_BLOCK_KEY);
  } catch {
    /* ignore */
  }
};

export const readOidcAutoLoginBlock = (): {
  active: boolean;
  reason: string | null;
  remainingMs: number;
} => {
  const current = readRawBlock();
  if (!current) {
    return { active: false, reason: null, remainingMs: 0 };
  }

  const remainingMs = current.until - Date.now();
  if (remainingMs <= 0) {
    clearOidcAutoLoginBlock();
    return { active: false, reason: null, remainingMs: 0 };
  }

  return {
    active: true,
    reason: current.reason,
    remainingMs,
  };
};

export const markOidcLoginAttempt = (): void => {
  try {
    sessionStorage.setItem(OIDC_LOGIN_ATTEMPT_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
};

export const clearOidcLoginAttempt = (): void => {
  try {
    sessionStorage.removeItem(OIDC_LOGIN_ATTEMPT_KEY);
  } catch {
    /* ignore */
  }
};

export const hasRecentOidcLoginAttempt = (): boolean => {
  try {
    const raw = sessionStorage.getItem(OIDC_LOGIN_ATTEMPT_KEY);
    if (!raw) {
      return false;
    }
    const startedAt = Number.parseInt(raw, 10);
    if (!Number.isFinite(startedAt)) {
      clearOidcLoginAttempt();
      return false;
    }
    const ageMs = Date.now() - startedAt;
    if (ageMs < 0 || ageMs > OIDC_LOGIN_ATTEMPT_TTL_MS) {
      clearOidcLoginAttempt();
      return false;
    }
    return true;
  } catch {
    return false;
  }
};

export {
  OIDC_AUTOLOGIN_BLOCK_KEY,
  OIDC_AUTOLOGIN_BLOCK_TTL_MS,
  OIDC_LOGIN_ATTEMPT_KEY,
  OIDC_LOGIN_ATTEMPT_TTL_MS,
};
